import React, { FC, useEffect, useState } from 'react';
import { SCUITabs, SCUINoData } from '../../atomic/atoms';
import { SCUIContent } from '../../atomic/organisms';
import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';
import { noImageIcon } from '../../assets/images';
import { SCUIGeneralDrawer, SCUICustomDataGrid, SCUIBreadCrumb, SCUIGrid } from '../../atomic/molecules';
import Button from '@mui/material/Button';
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    IconButton,
    Chip,
    Box,
    Typography,
    Divider,
    Tooltip,
} from '@mui/material';
import { initialState } from './ProductDetail.helper';
import StarIcon from '@mui/icons-material/Star';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import { ProductDetailServiceQuery, ProductSearchServiceQuery, SearchServiceQuery } from '../../services/query/';
import { SearchServiceCommand } from '../../services/command/';
import { useParams } from 'react-router-dom';
import { ExtendedGridColDef } from '@/types/ExtendedGridColDef';
import TimeHelper from '../../utils/time';
import ChildCareIcon from '@mui/icons-material/ChildCare';
import FemaleIcon from '@mui/icons-material/Female';
import MaleIcon from '@mui/icons-material/Male';
import lcwaikikiLogo from '../../assets/icons/svg/icons/lcwaikikiLogo.svg';
import { enumCellType } from '../../types/enums';
import { ProductDetailStoreFilter, ProductSizeInfo } from './components';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import SyncIcon from '@mui/icons-material/Sync';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import OpenInNewOutlinedIcon from '@mui/icons-material/OpenInNewOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import DOMPurify from 'dompurify';
import parse from 'html-react-parser';
import { PRD } from './productDetail.classes';

interface Params {
    optionId: string;
}

const selectedCityId = -1;
let languageCode = localStorage.getItem('lan')!;
let warehouseGroupId = JSON.parse(localStorage.getItem('selectedCountry') || '{}')?.warehouseGroupId;

export const ProductDetail: FC<any> = () => {
    const Params = useParams<Params>();
    const { t } = useTranslation();
    const [rightSideDatas, setRightSideDatas] = React.useState<any>();
    const [productContent, setProductContent] = React.useState<any>();
    const [leftSideDatas, setLeftSideDatas] = React.useState<any>();
    const [tabIndex, setTabIndex] = useState<any>(1);
    const [loading, setLoading] = React.useState(false);
    const [firstOpen, setFirstOpen] = React.useState(true);
    const [colorCode, setColorCode] = React.useState('');
    const [specialCode, setSpecialCode] = React.useState('');
    const [frontEndPageNumber, setFrontEndPageNumber] = React.useState(0);
    const [stockData, setStockData] = React.useState<any>();
    const [storeList, setStoreList] = React.useState<any>();
    const [cityList, setCityList] = useState<any[]>([]);
    const [selectedCity, setSelectedCity] = useState('');
    const [selectedCounty, setSelectedCounty] = useState('');
    const [selectedSize, setSelectedSize] = useState('');
    const [urunOptionSizeRefArr, setUrunOptionSizeRefArr] = useState<any[]>([]);
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [paginationCommentInfo, setPaginationCommentInfo] = useState(initialState.paginationCommentInfo);

    const _onChangeTabs = (event: any, activeTabIndex: any): void => {
        setTabIndex(activeTabIndex);
        if (activeTabIndex === 2) {
            getStockList();
        } else if (activeTabIndex === 3) {
            // Sorumlu Ekip
            //Method Çağırılacak.
        } else if (activeTabIndex === 4) {
            getCommentList();
        } else if (activeTabIndex === 5) {
            // Mağaza Stok Bilgileri
            //Method Çağırılacak.
            getCityList();
        }
    };

    const onDrawerOpen = () => setDrawerOpen(true);
    const onDrawerClose = () => setDrawerOpen(false);
    const handleCityDelete = () => {
        setSelectedCity('');
        setSelectedCounty('');
        setDrawerOpen(true);
    };
    const handleCountyDelete = () => {
        setSelectedCounty('');
        setDrawerOpen(true);
    };
    const handleSizeDelete = () => {
        setSelectedSize('');
        setDrawerOpen(true);
    };

    const columns: ExtendedGridColDef[] = [
        {
            field: 'size',
            headerName: t('productDetail.table.size'),
            flex: 1,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'stock',
            headerName: t('productDetail.table.stock'),
            flex: 1,
            headerAlign: 'center',
            align: 'center',
        },
    ];
    const storeColumns: ExtendedGridColDef[] = [
        {
            field: 'city',
            headerName: t('general.cityName'),
            flex: 1,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'county',
            headerName: t('general.countyName'),
            flex: 1,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'quantity',
            headerName: t('general.quantity'),
            flex: 1,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'storename',
            headerName: t('general.storeName'),
            flex: 1,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'Haritada Gör',
            headerName: '',
            align: 'center',
            headerAlign: 'center',
            flex: 1,
            disableColumnMenu: true,
            sortable: false,
            renderCell: (params: any) => {
                return (
                    <Tooltip title={t('productDetail.viewOnMap') || 'Haritada Gör'} arrow placement="left">
                        <IconButton
                            className={PRD.storeMapButton}
                            size="small"
                            onClick={() =>
                                window.open(
                                    'https://maps.google.com/?q=' + params.row.lattitude + ',' + params.row.longitude,
                                    '_blank'
                                )
                            }
                            sx={{
                                color: '#2563EB',
                                border: '1px solid #BFDBFE',
                                backgroundColor: '#EFF6FF',
                                borderRadius: '8px',
                                transition: 'all 0.15s ease',
                                '&:hover': {
                                    backgroundColor: '#DBEAFE',
                                    borderColor: '#2563EB',
                                    boxShadow: '0 2px 8px rgba(37,99,235,0.25)',
                                    transform: 'translateY(-1px)',
                                },
                            }}
                        >
                            <LocationOnOutlinedIcon fontSize="small" />
                        </IconButton>
                    </Tooltip>
                );
            },
        },
    ];
    const enumCommentStatus = [
        { id: 1, name: t('productDetail.comments.status.awaitingApproval') },
        { id: 2, name: t('productDetail.comments.status.approved') },
    ];
    const enumIndexTabs = [
        { id: 1, name: t('productDetail.tabs.productContent') },
        { id: 2, name: t('productDetail.tabs.stockInfo') },
        // { id: 3, name: "Sorumlu Ekip" },
        { id: 4, name: t('productDetail.tabs.comments') },
        { id: 5, name: t('productDetail.tabs.storeStock') },
        { id: 6, name: t('productDetail.tabs.productSizeInfo') },
    ];
    const [commentRowsPerPage, setCommentRowsPerPage] = React.useState(10);

    useEffect(() => {
        if (Params.optionId) {
            GetProductDetails();
        }
    }, [Params]);
    const openInNewTab = (url: string): void => {
        const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
        if (newWindow) newWindow.opener = null;
    };
    useEffect(() => {
        if (tabIndex === 4) getCommentList();
    }, [frontEndPageNumber, commentRowsPerPage]);

    const _onChangePage = (key: string, value: number) => {
        if (key === 'currentPage') {
            setPaginationCommentInfo((prevState: any) => ({
                ...prevState,
                [key]: value,
            }));
            if (paginationCommentInfo.currentPage == 0) {
                value = 1;
            }
            setFrontEndPageNumber(value + 1);
        } else if (key === 'rowsPerPage') {
            setPaginationCommentInfo((prevState: any) => ({
                ...prevState,
                [key]: value,
                currentPage: 0,
            }));
            setFrontEndPageNumber(0);
            setCommentRowsPerPage(value);
        }
    };
    const listele = (cityId: number, countyId: number, selectedSizeRef: number) => {
        let params: any = {};
        params.CityId = cityId;
        params.CountyId = countyId !== 0 ? countyId : '';
        params.UrunOptionSizeRef = selectedSizeRef;
        ProductDetailServiceQuery.GetStoreStock(params)
            .then((res: any) => {
                if (res.data) {
                    let parseData = res.data.map((item: any) => {
                        return {
                            id: item.storeId || '-',
                            city: item.storeCityName || '-',
                            county: item.storeCountyName || '',
                            storename: item.storeName || '',
                            lattitude: item.lattitude,
                            longitude: item.longitude,
                            quantity: item.quantity,
                        };
                    });
                    setStoreList(parseData);
                }
            })
            .catch((error: any) => {
                console.log('Hata :>> ', error);
            })
            .finally(() => {});
    };

    const getCityList = () => {
        ProductDetailServiceQuery.GetStoreCity()
            .then((res: any) => {
                if (res.data) {
                    setCityList(res.data);
                }
            })
            .catch((error: any) => {
                console.log('Hata :>> ', error);
            });
    };

    const getCommentList = () => {
        if (!loading) {
            setLoading(true);
            let param = {
                specialCode: specialCode,
                colorCode: colorCode,
                size: commentRowsPerPage,
                page: frontEndPageNumber,
                approveStatus: Number(enumCommentStatus[1].id),
            };
            ProductSearchServiceQuery.GetCommentDataV2(param)
                .then((res: any) => {
                    if (res) {
                        let parseData = res.data.map((item: any, index: any) => {
                            return {
                                id: index,
                                special: item.specialCode || '-',
                                commentDate: TimeHelper.formatDate(item.commentDate) || '-',
                                status: item.starScore || '-',
                                commentText: item.commentText || '-',
                            };
                        });
                        setRightSideDatas(parseData);
                        setPaginationCommentInfo({
                            rowsPerPage: commentRowsPerPage,
                            pageCount: res.totalPages,
                            totalCount: res.count,
                            currentPage: paginationCommentInfo.currentPage,
                        });
                    }
                })
                .catch((error: any) => {
                    console.log('Hata :>> ', error);
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    };
    const getStockList = () => {
        let params: any = {};
        params.optionId = String(Params.optionId);
        params.regionId = JSON.parse(localStorage.getItem('selectedCountry') || '{}')?.regionId?.toString();
        params.warehouseGroupId = warehouseGroupId;
        params.cultureCode = languageCode;
        ProductSearchServiceQuery.GetProductStockDetail(params)
            .then((res: any) => {
                if (res) {
                    let parseData = res.data.products.map((item: any) => {
                        return {
                            stock: item.stock,
                            size: item.size,
                        };
                    });
                    setStockData(parseData);
                }
            })
            .catch((error: any) => {
                console.log('Hata :>> ', error);
            })
            .finally(() => {});
    };
    const genderIcon = () => {
        if (leftSideDatas.productGroup === 'Erkek') {
            return <MaleIcon />;
        } else if (leftSideDatas.productGroup === 'Kadın') {
            return <FemaleIcon />;
        } else if (leftSideDatas.productGroup === 'Çocuk') {
            return <ChildCareIcon />;
        } else {
            return null;
        }
    };
    const GetProductDetails = async (params?: any) => {
        setLoading(true);

        params = {
            optionId: Params.optionId,
            warehouseGroupId: JSON.parse(localStorage.getItem('selectedCountry') || '{}')?.warehouseGroupId?.toString(),
        };
        ProductSearchServiceQuery.GetProductDetail(params)
            .then((res: any) => {
                if (!res.data.modelTitle) {
                    Swal.fire({
                        icon: 'error',
                        title: t('general.error'),
                        text: res.data.message,
                        footer: `<a href="/productSearch">${t('productDetail.navigation.backToSearch')}</a>`,
                    });
                    return;
                }
                setLeftSideDatas(res.data);
                setProductContent(res.data);

                setColorCode(res.data.option.renkKod);
                setSpecialCode(res.data.option.ozelKod1);
                let urunOptionSizeRefandSize = res.data.option.products.map((item: any) => {
                    return {
                        size: item.size.cultureValueList[languageCode],
                        urunOptionSizeRef: item.urunOptionSizeRef,
                    };
                });
                setUrunOptionSizeRefArr(urunOptionSizeRefandSize);
            })
            .finally(() => {
                setLoading(false);
            });
    };
    const GetStockByProduct = async () => {
        let params: any = {
            optionId: String(Params.optionId),
        };
        SearchServiceCommand.GetStockByProduct(params)
            .then((res: any) => {
                Swal.fire(res, ' ', 'success');
            })
            .catch(() => {
                Swal.fire(t('general.error'), ' ', 'error');
            });
    };
    const GetTeknikFoy = async () => {
        let params = {
            OzelKod: leftSideDatas?.ozelKod1,
        };
        SearchServiceQuery.GetTeknikFoy(params)
            .then((res: any) => {
                openInNewTab(res?.data[0]?.imageUrl);
            })
            .catch((error: any) => {
                console.log('Hata :>> ', error);
            });
    };
    function renderHTML(html: string) {
        return parse(DOMPurify.sanitize(html));
    }
    const infoRowSx = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        py: 0.875,
        px: 1.25,
        borderRadius: '6px',
        borderBottom: '1px solid #F3F4F6',
        transition: 'background-color 0.15s ease',
        '&:hover': { backgroundColor: '#F9FAFB' },
    };
    const labelSx = {
        fontSize: '0.7rem',
        color: '#9CA3AF',
        fontWeight: 700,
        textTransform: 'uppercase' as const,
        letterSpacing: '0.06em',
        flexShrink: 0,
        mr: 1,
    };
    const valueSx = {
        fontSize: '0.875rem',
        color: '#111827',
        fontWeight: 600,
        textAlign: 'right' as const,
    };

    return (
        <SCUIContent className={PRD.page}>
            <Grid className={PRD.breadcrumbSection} size={{ sm: 12, md: 10, lg: 10, xl: 9 }}>
                <SCUIBreadCrumb
                    components={[
                        { title: t('searchService.searchProduct'), link: '/productSearch' },
                        { title: t('general.productDetail'), link: '/productDetail/' + Params.optionId },
                    ]}
                />
            </Grid>
            <Paper
                className={PRD.cardPaper}
                sx={{
                    marginTop: '20px',
                    borderRadius: '16px',
                    border: '1px solid #E5E7EB',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.06), 0 8px 32px rgba(0,0,0,0.06)',
                    overflow: 'hidden',
                }}
            >
                {leftSideDatas && (
                    <Grid className={PRD.layout} container size={{ lg: 12, md: 12, xs: 12 }}>
                        {/* ───────────────── LEFT PANEL ───────────────── */}
                        <Grid
                            className={PRD.leftPanel}
                            size={{ lg: 4.8, md: 5, xs: 12 }}
                            sx={{ borderRight: '1px solid #E5E7EB', backgroundColor: '#FAFAFA' }}
                        >
                            <Box sx={{ p: 4 }}>
                                {/* Brand + Purchasable badge + Season */}
                                <Box
                                    className={PRD.leftHeaderRow}
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        mb: 2,
                                    }}
                                >
                                    <Box>
                                        {leftSideDatas?.brand === 'LC WAIKIKI' ? (
                                            <img src={lcwaikikiLogo} alt="LC Waikiki" style={{ height: 26 }} />
                                        ) : (
                                            <Typography sx={{ fontWeight: 700, fontSize: '1.1rem', color: '#111827' }}>
                                                {leftSideDatas?.brand}
                                            </Typography>
                                        )}
                                    </Box>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                        <Chip
                                            className={PRD.purchasableChip}
                                            label={
                                                leftSideDatas?.isPurchasable
                                                    ? t('searchService.isPurchasable')
                                                    : t('searchService.unPurchasable')
                                            }
                                            size="small"
                                            sx={{
                                                backgroundColor: leftSideDatas?.isPurchasable ? '#DCFCE7' : '#FEE2E2',
                                                color: leftSideDatas?.isPurchasable ? '#15803D' : '#DC2626',
                                                border: `1px solid ${leftSideDatas?.isPurchasable ? '#86EFAC' : '#FCA5A5'}`,
                                                fontWeight: 700,
                                                fontSize: '0.7rem',
                                                height: 24,
                                            }}
                                        />
                                        {leftSideDatas?.option?.seasonCode && (
                                            <Typography
                                                className={PRD.seasonCode}
                                                sx={{
                                                    fontSize: '0.75rem',
                                                    color: '#9CA3AF',
                                                    fontWeight: 600,
                                                    letterSpacing: '0.04em',
                                                }}
                                            >
                                                {leftSideDatas?.option?.seasonCode}
                                            </Typography>
                                        )}
                                    </Box>
                                </Box>

                                {/* Product Title */}
                                <Typography
                                    className={PRD.productTitle}
                                    sx={{
                                        fontWeight: 700,
                                        fontSize: '1.2rem',
                                        color: '#111827',
                                        mb: 2.5,
                                        lineHeight: 1.35,
                                    }}
                                >
                                    {leftSideDatas?.modelTitle[languageCode]}
                                </Typography>

                                {/* Product Image */}
                                <Box
                                    className={PRD.imageCard}
                                    sx={{
                                        position: 'relative',
                                        borderRadius: '12px',
                                        overflow: 'hidden',
                                        border: '1px solid #E5E7EB',
                                        mb: 3,
                                        boxShadow: '0 2px 12px rgba(0,0,0,0.07)',
                                        backgroundColor: '#fff',
                                    }}
                                >
                                    <img
                                        className={PRD.productImage + ' centeredImg'}
                                        alt={leftSideDatas?.modelTitle[languageCode]}
                                        src={
                                            leftSideDatas?.picture !== null
                                                ? leftSideDatas?.picture
                                                : leftSideDatas?.option?.medias != null
                                                  ? leftSideDatas?.option?.medias[0]?.mediaPath
                                                  : noImageIcon
                                        }
                                        style={{ maxWidth: '100%', display: 'block' }}
                                    />
                                    {leftSideDatas?.option?.color && (
                                        <Box sx={{ position: 'absolute', top: 10, left: 10 }}>
                                            <Chip
                                                className={PRD.colorChip}
                                                label={leftSideDatas?.option?.color?.cultureValueList[languageCode]}
                                                size="small"
                                                sx={{
                                                    backgroundColor: 'rgba(255,255,255,0.9)',
                                                    fontWeight: 700,
                                                    fontSize: '0.72rem',
                                                    color: '#374151',
                                                    border: '1px solid rgba(0,0,0,0.08)',
                                                    boxShadow: '0 1px 6px rgba(0,0,0,0.12)',
                                                    backdropFilter: 'blur(4px)',
                                                }}
                                            />
                                        </Box>
                                    )}
                                </Box>

                                {/* Info rows: gender, compositions, properties */}
                                <Box
                                    className={PRD.infoRowsCard}
                                    sx={{
                                        mb: 3,
                                        borderRadius: '10px',
                                        border: '1px solid #F3F4F6',
                                        overflow: 'hidden',
                                    }}
                                >
                                    {/* Gender */}
                                    <Box sx={infoRowSx}>
                                        <Typography sx={labelSx}>{t('productDetail.gender')}</Typography>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
                                            <Box
                                                sx={{
                                                    color: '#6B7280',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    '& svg': { fontSize: '1rem' },
                                                }}
                                            >
                                                {genderIcon()}
                                            </Box>
                                            <Typography sx={valueSx}>{leftSideDatas?.gender[languageCode]}</Typography>
                                        </Box>
                                    </Box>
                                    {/* Compositions */}
                                    {leftSideDatas?.option?.compositions.map((item: any, index: any) => (
                                        <Box key={`composition-${index}`} sx={infoRowSx}>
                                            <Typography sx={labelSx}>{item.compositionName[languageCode]}</Typography>
                                            <Typography sx={valueSx}>
                                                {item.compositionValueName[languageCode]}
                                            </Typography>
                                        </Box>
                                    ))}
                                    {/* Properties */}
                                    {leftSideDatas?.option?.propertyList.map((item: any, index: any) => (
                                        <Box key={`property-${item.propertyId}-${index}`} sx={infoRowSx}>
                                            <Typography sx={labelSx}>{item.propertyName[languageCode]}</Typography>
                                            <Typography sx={valueSx}>{item.propertyValueName[languageCode]}</Typography>
                                        </Box>
                                    ))}
                                </Box>

                                {/* Size chips */}
                                <Divider sx={{ mb: 2 }} />
                                <Typography
                                    sx={{
                                        fontSize: '0.7rem',
                                        fontWeight: 700,
                                        color: '#9CA3AF',
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.06em',
                                        mb: 1.5,
                                    }}
                                >
                                    {t('productDetail.sizeInformation')}
                                </Typography>
                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 2 }}>
                                    {leftSideDatas?.option?.products.map((item: any) => (
                                        <Chip
                                            className={PRD.sizeChip}
                                            key={item.productId}
                                            label={item.size.cultureValueList[languageCode]}
                                            variant="outlined"
                                            sx={{
                                                fontWeight: 600,
                                                fontSize: '0.8rem',
                                                borderColor: '#D1D5DB',
                                                color: '#374151',
                                                transition: 'all 0.15s ease',
                                                '&:hover': { backgroundColor: '#F3F4F6', borderColor: '#9CA3AF' },
                                            }}
                                        />
                                    ))}
                                </Box>

                                {/* Mannequin measurements */}
                                {leftSideDatas?.option?.mannequin && (
                                    <Box
                                        className={PRD.mannequinTableWrap}
                                        sx={{
                                            overflowX: 'auto',
                                            mb: 2,
                                            borderRadius: '8px',
                                            border: '1px solid #E5E7EB',
                                            overflow: 'hidden',
                                        }}
                                    >
                                        <Table size="small">
                                            <TableHead>
                                                <TableRow sx={{ backgroundColor: '#F9FAFB' }}>
                                                    {[
                                                        t('productKeys.chest'),
                                                        t('productKeys.hip'),
                                                        t('productKeys.length'),
                                                        t('productKeys.barcode'),
                                                    ].map((h) => (
                                                        <TableCell
                                                            key={h}
                                                            sx={{
                                                                fontWeight: 700,
                                                                fontSize: '0.7rem',
                                                                color: '#6B7280',
                                                                textTransform: 'uppercase',
                                                                letterSpacing: '0.05em',
                                                                textAlign: 'center',
                                                                borderBottom: '1px solid #E5E7EB',
                                                                py: 1,
                                                            }}
                                                        >
                                                            {h}
                                                        </TableCell>
                                                    ))}
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                <TableRow>
                                                    {[
                                                        leftSideDatas?.option?.mannequin?.chest,
                                                        leftSideDatas?.option?.mannequin?.hip,
                                                        leftSideDatas?.option?.mannequin?.length,
                                                        leftSideDatas?.option?.mannequin?.barcode,
                                                    ].map((v, i) => (
                                                        <TableCell
                                                            key={i}
                                                            sx={{
                                                                fontWeight: 600,
                                                                fontSize: '0.875rem',
                                                                color: '#111827',
                                                                textAlign: 'center',
                                                                borderBottom: 'none',
                                                                py: 1.25,
                                                            }}
                                                        >
                                                            {v}
                                                        </TableCell>
                                                    ))}
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </Box>
                                )}

                                {/* Action buttons */}
                                <Divider sx={{ mb: 2.5, mt: 1 }} />
                                <Box className={PRD.actionButtonsRow} sx={{ display: 'flex', gap: 1.5 }}>
                                    <Button
                                        className={PRD.showOnSiteButton}
                                        fullWidth
                                        variant="contained"
                                        color="info"
                                        startIcon={<OpenInNewOutlinedIcon />}
                                        sx={{
                                            color: 'white',
                                            borderRadius: '8px',
                                            padding: '8px 16px !important',
                                            textTransform: 'none',
                                            fontWeight: 600,
                                            fontSize: '0.875rem',
                                            py: 1.1,
                                            boxShadow: '0 2px 8px rgba(2,132,199,0.3)',
                                            transition: 'all 0.2s ease',
                                            '&:hover': {
                                                boxShadow: '0 4px 16px rgba(2,132,199,0.45)',
                                                transform: 'translateY(-1px)',
                                            },
                                        }}
                                        onClick={() =>
                                            openInNewTab(
                                                'https://www.lcw.com/model/?modelId=' +
                                                    leftSideDatas?.modelId +
                                                    '&optionId=' +
                                                    Params.optionId
                                            )
                                        }
                                    >
                                        {t('general.showOnSite')}
                                    </Button>
                                    <Button
                                        className={PRD.teknikFoyButton}
                                        fullWidth
                                        variant="outlined"
                                        color="error"
                                        startIcon={<DescriptionOutlinedIcon />}
                                        sx={{
                                            borderRadius: '8px',
                                            textTransform: 'none',
                                            fontWeight: 600,
                                            fontSize: '0.875rem',
                                            py: 1.1,
                                            transition: 'all 0.2s ease',
                                            '&:hover': {
                                                backgroundColor: '#FEF2F2',
                                                boxShadow: '0 4px 16px rgba(220,38,38,0.15)',
                                                transform: 'translateY(-1px)',
                                            },
                                        }}
                                        onClick={() => GetTeknikFoy()}
                                    >
                                        {t('general.teknikFoy')}
                                    </Button>
                                </Box>
                            </Box>
                        </Grid>

                        {/* ───────────────── RIGHT PANEL (Tabs) ───────────────── */}
                        <Grid className={PRD.rightPanel} size={{ lg: 7.2, md: 7, xs: 12 }}>
                            <Box sx={{ p: 4 }}>
                                <div className={PRD.tabs}>
                                    <SCUITabs
                                        tabList={Object.values(enumIndexTabs)}
                                        onChange={_onChangeTabs}
                                        activeTabIndex={tabIndex}
                                    />
                                </div>

                                {/* ── Tab 1: Product Content ── */}
                                {tabIndex === 1 && productContent && (
                                    <Box className={PRD.tabPanelProductContent} sx={{ mt: 3, display: 'flex', gap: 4 }}>
                                        {/* Left col: Description + Return Policy */}
                                        <Box sx={{ flex: 1, minWidth: 0 }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '0.7rem',
                                                    fontWeight: 700,
                                                    color: '#9CA3AF',
                                                    textTransform: 'uppercase',
                                                    letterSpacing: '0.06em',
                                                    mb: 1,
                                                }}
                                            >
                                                {t('productDetail.productContentInfo')}
                                            </Typography>
                                            <Divider sx={{ mb: 2 }} />
                                            <Typography
                                                sx={{ fontWeight: 700, fontSize: '0.9rem', color: '#374151', mb: 1 }}
                                            >
                                                {t('general.description')}
                                            </Typography>
                                            <Box
                                                sx={{
                                                    fontSize: '1.2rem',
                                                    lineHeight: 1.8,
                                                    color: '#4B5563',
                                                    '& ul': { pl: 2 },
                                                    '& li': { mb: 0.5 },
                                                }}
                                            >
                                                {renderHTML(productContent.option.modelDescription[languageCode])}
                                            </Box>
                                            {productContent.IsReturnable && (
                                                <Box
                                                    sx={{
                                                        mt: 2.5,
                                                        p: 2,
                                                        backgroundColor: '#F0FDF4',
                                                        border: '1px solid #BBF7D0',
                                                        borderRadius: '8px',
                                                    }}
                                                >
                                                    <Typography
                                                        sx={{
                                                            fontWeight: 700,
                                                            fontSize: '0.85rem',
                                                            color: '#15803D',
                                                            mb: 0.5,
                                                        }}
                                                    >
                                                        {t('productDetail.returnPolicy.title')}
                                                    </Typography>
                                                    <Typography
                                                        sx={{ fontSize: '0.8rem', color: '#166534', lineHeight: 1.6 }}
                                                    >
                                                        {t('productDetail.returnPolicy.description')}
                                                    </Typography>
                                                </Box>
                                            )}
                                        </Box>
                                        {/* Right col: Features + Care */}
                                        <Box sx={{ flex: 1, minWidth: 0 }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '0.7rem',
                                                    fontWeight: 700,
                                                    color: '#9CA3AF',
                                                    textTransform: 'uppercase',
                                                    letterSpacing: '0.06em',
                                                    mb: 1,
                                                }}
                                            >
                                                {t('productDetail.productFeatures')}
                                            </Typography>
                                            <Divider sx={{ mb: 1.5 }} />
                                            <Box
                                                sx={{
                                                    borderRadius: '10px',
                                                    border: '1px solid #F3F4F6',
                                                    overflow: 'hidden',
                                                    mb: 3,
                                                }}
                                            >
                                                {productContent.option.propertyList.map((item: any, index: any) => (
                                                    <Box
                                                        key={`product-property-${item.propertyId}-${index}`}
                                                        sx={infoRowSx}
                                                    >
                                                        <Typography sx={labelSx}>
                                                            {item.propertyName[languageCode]}
                                                        </Typography>
                                                        <Typography sx={valueSx}>
                                                            {item.propertyValueName[languageCode]}
                                                        </Typography>
                                                    </Box>
                                                ))}
                                            </Box>
                                            {productContent?.option?.careInstructions?.length > 0 && (
                                                <>
                                                    <Typography
                                                        sx={{
                                                            fontSize: '0.7rem',
                                                            fontWeight: 700,
                                                            color: '#9CA3AF',
                                                            textTransform: 'uppercase',
                                                            letterSpacing: '0.06em',
                                                            mb: 1,
                                                        }}
                                                    >
                                                        {t('productDetail.careInstructions')}
                                                    </Typography>
                                                    <Divider sx={{ mb: 1.5 }} />
                                                    <Box
                                                        sx={{
                                                            p: 1.5,
                                                            backgroundColor: '#F9FAFB',
                                                            border: '1px solid #E5E7EB',
                                                            borderRadius: '10px',
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            gap: 0.75,
                                                        }}
                                                    >
                                                        {productContent?.option?.careInstructions?.map(
                                                            (item: any, index: any) => (
                                                                <Box
                                                                    key={`care-instruction-${index}`}
                                                                    sx={{
                                                                        display: 'flex',
                                                                        alignItems: 'flex-start',
                                                                        gap: 1,
                                                                    }}
                                                                >
                                                                    <Box
                                                                        sx={{
                                                                            width: 4,
                                                                            height: 4,
                                                                            borderRadius: '50%',
                                                                            backgroundColor: '#9CA3AF',
                                                                            mt: '8px',
                                                                            flexShrink: 0,
                                                                        }}
                                                                    />
                                                                    <Typography
                                                                        sx={{
                                                                            fontSize: '0.8rem',
                                                                            color: '#374151',
                                                                            lineHeight: 1.65,
                                                                        }}
                                                                    >
                                                                        {item.cultureValueList[languageCode]}
                                                                    </Typography>
                                                                </Box>
                                                            )
                                                        )}
                                                    </Box>
                                                </>
                                            )}
                                        </Box>
                                    </Box>
                                )}

                                {/* ── Tab 2: Stock Info ── */}
                                {tabIndex === 2 && (
                                    <Box
                                        className={PRD.tabPanelStockInfo}
                                        sx={{
                                            mt: 3,
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            gap: 3,
                                        }}
                                    >
                                        <Button
                                            className={PRD.refreshStockButton}
                                            variant="contained"
                                            color="primary"
                                            startIcon={<SyncIcon />}
                                            size="large"
                                            sx={{
                                                color: 'white',
                                                borderRadius: '8px',
                                                fontWeight: 600,
                                                textTransform: 'none',
                                                padding: '8px 16px !important',
                                                fontSize: '0.9rem',
                                                boxShadow: '0 2px 8px rgba(25,118,210,0.3)',
                                                transition: 'all 0.2s ease',
                                                '&:hover': {
                                                    boxShadow: '0 4px 16px rgba(25,118,210,0.45)',
                                                    transform: 'translateY(-1px)',
                                                },
                                            }}
                                            onClick={() => GetStockByProduct()}
                                        >
                                            {t('productDetail.buttons.getStock')}
                                        </Button>
                                        {stockData && stockData.length > 0 && (
                                            <Box className={PRD.stockGridWrap} sx={{ width: '100%' }}>
                                                <SCUICustomDataGrid
                                                    fullwidth
                                                    randomId
                                                    rows={stockData}
                                                    columns={columns}
                                                />
                                            </Box>
                                        )}
                                    </Box>
                                )}

                                {/* ── Tab 4: Comments ── */}
                                {tabIndex === 4 && (
                                    <Box className={PRD.tabPanelComments} sx={{ mt: 3 }}>
                                        <div className={PRD.commentsGridWrap}>
                                            <SCUIGrid
                                                rows={rightSideDatas}
                                                headCells={[
                                                    {
                                                        id: 'commentDate',
                                                        numeric: false,
                                                        disablePadding: true,
                                                        label: t('comments.date'),
                                                        cellType: enumCellType.string,
                                                    },
                                                    {
                                                        id: 'commentText',
                                                        numeric: false,
                                                        disablePadding: true,
                                                        label: t('comments.comment'),
                                                        cellType: enumCellType.string,
                                                    },
                                                    {
                                                        id: 'status',
                                                        numeric: false,
                                                        disablePadding: true,
                                                        label: t('general.point'),
                                                        icon: StarIcon,
                                                        cellType: enumCellType.icons,
                                                    },
                                                ]}
                                                paginationInfo={paginationCommentInfo}
                                                loading={loading}
                                                onChangePage={(event, value) => _onChangePage(event, value)}
                                            />
                                        </div>
                                    </Box>
                                )}

                                {/* ── Tab 5: Store Stock ── */}
                                {tabIndex === 5 && (
                                    <Box className={PRD.tabPanelStoreStock} sx={{ mt: 3 }}>
                                        <Box
                                            className={PRD.storeStockHeaderRow}
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'space-between',
                                                mb: 2,
                                            }}
                                        >
                                            <Typography sx={{ fontWeight: 700, fontSize: '1rem', color: '#111827' }}>
                                                {t('productDetail.storeStockInfo')}
                                            </Typography>
                                            <Button
                                                className={PRD.openStoreFilterButton}
                                                variant="outlined"
                                                startIcon={<FilterAltOutlinedIcon />}
                                                onClick={() => onDrawerOpen()}
                                                sx={{
                                                    borderRadius: '8px',
                                                    textTransform: 'none',
                                                    fontWeight: 600,
                                                    fontSize: '0.875rem',
                                                    padding: '8px 16px !important',
                                                    borderColor: 'primary.main',
                                                    transition: 'all 0.15s ease',
                                                    '&:hover': {
                                                        backgroundColor: '#EFF6FF',
                                                        boxShadow: '0 2px 8px rgba(25,118,210,0.2)',
                                                    },
                                                }}
                                            >
                                                {t('general.filter') || 'Filtre'}
                                            </Button>
                                        </Box>
                                        {(selectedCity || selectedCounty || selectedSize) && (
                                            <Box
                                                className={PRD.selectedFiltersRow}
                                                sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mb: 2 }}
                                            >
                                                {selectedCity && (
                                                    <Chip
                                                        className={PRD.selectedCityChip}
                                                        label={selectedCity}
                                                        onDelete={handleCityDelete}
                                                        sx={{
                                                            backgroundColor: '#EFF6FF',
                                                            color: '#1D4ED8',
                                                            border: '1px solid #BFDBFE',
                                                            fontWeight: 600,
                                                            '& .MuiChip-deleteIcon': {
                                                                color: '#93C5FD',
                                                                '&:hover': { color: '#1D4ED8' },
                                                            },
                                                        }}
                                                    />
                                                )}
                                                {selectedCounty && (
                                                    <Chip
                                                        className={PRD.selectedCountyChip}
                                                        label={selectedCounty}
                                                        onDelete={handleCountyDelete}
                                                        sx={{
                                                            backgroundColor: '#F0FDF4',
                                                            color: '#15803D',
                                                            border: '1px solid #BBF7D0',
                                                            fontWeight: 600,
                                                            '& .MuiChip-deleteIcon': {
                                                                color: '#86EFAC',
                                                                '&:hover': { color: '#15803D' },
                                                            },
                                                        }}
                                                    />
                                                )}
                                                {selectedSize && (
                                                    <Chip
                                                        className={PRD.selectedSizeChip}
                                                        label={selectedSize}
                                                        onDelete={handleSizeDelete}
                                                        sx={{
                                                            backgroundColor: '#FDF4FF',
                                                            color: '#7C3AED',
                                                            border: '1px solid #E9D5FF',
                                                            fontWeight: 600,
                                                            '& .MuiChip-deleteIcon': {
                                                                color: '#C4B5FD',
                                                                '&:hover': { color: '#7C3AED' },
                                                            },
                                                        }}
                                                    />
                                                )}
                                            </Box>
                                        )}
                                        <SCUIGeneralDrawer
                                            width={'300px'}
                                            open={drawerOpen}
                                            paperClassName={PRD.storeFilterDrawerPaper}
                                            onClose={(event: any, reason: any) => {
                                                if (reason === 'backdropClick') setDrawerOpen(false);
                                            }}
                                        >
                                            <div className={PRD.storeFilterDrawerContent}>
                                                <ProductDetailStoreFilter
                                                    cities={cityList}
                                                    onClose={onDrawerClose}
                                                    listele={listele}
                                                    setSelectedCity={setSelectedCity}
                                                    setSelectedCounty={setSelectedCounty}
                                                    setFirstOpen={setFirstOpen}
                                                    selectedCityId={selectedCityId}
                                                    urunOptionSizeRefArr={urunOptionSizeRefArr}
                                                    setSelectedSize={setSelectedSize}
                                                />
                                            </div>
                                        </SCUIGeneralDrawer>
                                        {storeList && storeList.length > 0 ? (
                                            <div className={PRD.storeGridWrap}>
                                                <SCUICustomDataGrid
                                                    fullwidth
                                                    randomId
                                                    rows={storeList}
                                                    columns={storeColumns}
                                                />
                                            </div>
                                        ) : (
                                            !firstOpen && (
                                                <Box
                                                    className={PRD.emptyNoDataWrap}
                                                    sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}
                                                >
                                                    <TableRow className="sc-grid__table-row">
                                                        <TableCell colSpan={7} className="sc-grid__table-cell">
                                                            <SCUINoData message={t('general.noDataFound')} />
                                                        </TableCell>
                                                    </TableRow>
                                                </Box>
                                            )
                                        )}
                                    </Box>
                                )}
                                {/* ── Tab 6: Product Size Info ── */}
                                {tabIndex === 6 && (
                                    <Box className={PRD.tabPanelProductSizeInfo} sx={{ mt: 3 }}>
                                        <Typography
                                            sx={{ fontWeight: 700, fontSize: '1rem', color: '#111827', mb: 2 }}
                                        >
                                            {t('productDetail.productSizeInfo')}
                                        </Typography>
                                        <ProductSizeInfo specialCode={specialCode} />
                                    </Box>
                                )}
                            </Box>
                        </Grid>
                    </Grid>
                )}
            </Paper>
        </SCUIContent>
    );
};
